import { render, staticRenderFns } from "./HistoryItemSkill.vue?vue&type=template&id=1571059a&scoped=true"
import script from "./HistoryItemSkill.vue?vue&type=script&lang=js"
export * from "./HistoryItemSkill.vue?vue&type=script&lang=js"
import style0 from "./HistoryItemSkill.vue?vue&type=style&index=0&id=1571059a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571059a",
  null
  
)

export default component.exports